// extracted by mini-css-extract-plugin
module.exports = {"social_icons":"style_social_icons__vR9KY","animate_icons":"style_animate_icons__8iaeK","icon-wobble":"style_icon-wobble__1DrjB"};